import React from 'react'

const Itind_RU = () => {
    return (
        <section id="about1">
            <div className="row">
                <h2>Лечение методикой iTind</h2>
                <p className="white">
                    iTind - это временно имплантированное устройство из нитинола, которое обеспечивает быстрое облегчение симптомов аденомы простательной железы  за счет минимально инвазивного лечения.<br/>
                    ITind является простой и понятной процедурой. Устройство вводится в простату, где оно расширяется и оказывает локальное ишемическое давление на ткань. Это давление направлено на изменение формы ткани простатической уретры и шейки мочевого пузыря, создавая три продольных канала, по которым может проходить моча.<br/>
                    Пациенты могут вернуться домой в течение 5-7 дней лечения. По истечении 5-7 дней имплантации устройство полностью удаляется.
                    The iTind is placed in the prostatic urethra in a narrow, folded configuration under vision.
                    <br/>
                    <h2>Как работает методика iTind?</h2>
                    <img
                        src="https://cdn.mannheim-urology.com/photos/itind.png"
                        alt="iTind Метод"
                    />
                    ITind помещается в простатическую уретру в узкой складчатой форме.
                    В течение 5-7 дней лечения устройство расширяет круг своего действия и оказывает постоянное давление в положениях на 5, 7 и 12 часов, чтобы реконструировать простатическую уретру и шейку мочевого пузыря.
                    <br/>
                    Через 5-7 дней устройство полностью удаляется, чтобы оставить более широкое отверстие, через которое может проходить моча, облегчая при этом симптомы аденомы простаты.
                    <br/>
                    <h2>Клинические доказательства</h2>
                    Клинические данные демонстрируют, что TIND первого поколения может похвастаться трехлетним сроком службы, а высокая эффективность через 36 месяцев также продемонстрирована коммерчески доступным iTind второго поколения.
                    <br/>
                    <ol>
                        <li>Быстрое и эффективное облегчение симптомов аденомы простаты.</li>
                        <li>Более низкий профиль риска, чем более инвазивные процедуры.</li>
                        <li>Процедура без  использования катетера.</li>
                        <li>Сохраняет половую и эякуляторную функцию</li>
                        <li>Отсутсвие постоянного имплантата после процедуры.</li>
                        <li>Относительно простая процедура.</li>
                    </ol>
                </p>
            </div>
        </section>
    )
}

export default Itind_RU



// WEBPACK FOOTER //
// ./src/Components/Itind/Itind_RU.js